import kr from './kor.png'
import us from './usa.png'
import jp from './jpn.png'

export const flags = { kr, us, jp };
